import { useContext } from 'react'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import LinearProgress from '@mui/material/LinearProgress'
import Logo from './Logo'
import { Section } from '@wolfdanepug/common-react'
import { GetUnstableData } from '../graphql/docs'
import { useQuery } from '../lib/useQuery'
import { AppContext } from '../context/app/AppContext'
import { useNavigator } from '../lib/useNavigator'

export interface HeaderProps {
	position?: 'fixed' | 'sticky' | 'static' | 'relative' | 'absolute'
	height?: number
	heightOnScroll?: number
	isMobile?: boolean
}

export default function Header({
	position = 'fixed',
	height = 110,
	heightOnScroll = 100,
	isMobile
}: HeaderProps) {
	const { data } = useQuery(GetUnstableData, { context: 'onboarding' }, 'cache-only')
	const { useAppState } = useContext(AppContext)
	const state: any = useAppState()
	const navigation = useNavigator(data)

	return (
		<AppBar
			position={position}
			sx={{
				backgroundColor: '#000',
				color: 'text.primary',
				boxShadow: 0
			}}
		>
			<Container maxWidth="xl">
				<Toolbar
					disableGutters
					sx={{
						height: {
							xs: 80,
							md: height
						},
						transition: 'height 0.3s'
					}}
				>
					<Logo width={155} sx={{ root: { zIndex: 1102 } }} isMobile={isMobile} />
					<Box
						id="header-portal"
						component={'span'}
						sx={{
							flex: 1,
							position: 'relative',
							display: {
								xs: 'none',
								md: 'flex'
							}
						}}
					>
						<Section
							sx={styles.stepper}
							containerProps={
								{
									// maxWidth: 'md',
									// width: '100%'
								}
							}
						>
							{navigation}
						</Section>
					</Box>
				</Toolbar>
			</Container>
			<Box sx={{ position: 'absolute', bottom: -4, width: '100%', zIndex: 1101 }}>
				{state?.loading && <LinearProgress />}
			</Box>
		</AppBar>
	)
}

const styles = {
	stepper: {
		root: {
			// position: 'absolute',
			// bottom: '-30px'
		},
		container: {
			// p: 3
		}
	}
}
